import React, { useState } from 'react';
import '../styles/advertise.scss';

import CONTENT from '../constants/content';
import Emulator from '../assets/advertise.gif';

function Advertise() {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className="Advertise">
      <div className="container container-advertise">
        <div className="advertise-div">
          <img
            className="advertise-emulator"
            alt="Emulator"
            src={Emulator}
          ></img>
        </div>

        <div className="content-container-advertise">
          <p className="titleAdvertise">Advertise with us</p>
          <p className="textAdvertise">
            {expanded ? CONTENT.advertiseMore : CONTENT.advertise}
          </p>
          <p
            onClick={() => setExpanded(!expanded)}
            className="readMoreAdvertise"
          >
            {expanded ? 'Read less <' : 'Read more >'}
          </p>
        </div>
      </div>
    </div>
  );
}

export default Advertise;
